import React from 'react';

const C = {
  trasporto: '#EB1C24',
  alloggio: '#0071BA',
  attivita: '#FF5B00',
  servizi: '#009045',
  dark: '#0a1628',
  white: '#ffffff',
  text: '#1a1a2e',
  textLight: '#6b7280',
  border: '#e0e4ea',
};

const MOBILE_CSS = `
  .pktd-row { display: grid; grid-template-columns: 1fr 1fr; }
  @media (max-width: 600px) {
    .pktd-row { grid-template-columns: 1fr !important; }
    .pktd-logo { display: none !important; }
    .pktd-cell-tl { border-right: none !important; }
    .pktd-cell-bl { border-right: none !important; border-bottom: 2px solid #e0e4ea !important; }
    .pktd-header { padding: 10px 10px !important; gap: 6px !important; }
    .pktd-header-title { font-size: 20px !important; }
    .pktd-header-price { font-size: 15px !important; }
    .pktd-header-meta { font-size: 12px !important; }
    .pktd-header-sub { font-size: 10px !important; }
    .pktd-cell { padding: 7px 8px !important; }
    .pktd-seglabel { margin-bottom: 8px !important; }
    .pktd-seglabel-icon { height: 14px !important; }
    .pktd-seglabel-text { font-size: 11px !important; }
    .pktd-volo-badge-row { margin-bottom: 3px !important; }
    .pktd-volo-time { font-size: 13px !important; }
    .pktd-volo-city { font-size: 10px !important; }
    .pktd-volo-mid { font-size: 10px !important; }
    .pktd-volo-price { font-size: 13px !important; }
    .pktd-volo-gap { height: 5px !important; }
    .pktd-alloggio-head { margin-bottom: 5px !important; }
    .pktd-alloggio-title { font-size: 13px !important; }
    .pktd-alloggio-meta { font-size: 11px !important; }
    .pktd-alloggio-price { font-size: 13px !important; }
    .pktd-features { gap: 3px 8px !important; margin-top: 5px !important; padding-top: 5px !important; }
    .pktd-feature-text { font-size: 11px !important; }
    .pktd-list-row { padding: 3px 0 !important; }
    .pktd-list-text { font-size: 12px !important; }
    .pktd-list-price { font-size: 13px !important; }
    .pktd-footer { padding: 7px 12px !important; }
    .pktd-footer-pct { font-size: 15px !important; }
    .pktd-footer-text { font-size: 12px !important; }
  }
`;

export default function PacchettoCardDemo() {
  return (
    <div style={{ backgroundColor: C.white, borderRadius: '16px', overflow: 'hidden', border: `1px solid ${C.border}`, boxShadow: '0 4px 24px rgba(0,0,0,0.10)', fontFamily: 'Roboto, sans-serif', textAlign: 'left' }}>
      <style>{MOBILE_CSS}</style>

      {/* HEADER */}
      <div className="pktd-header" style={{ backgroundColor: C.dark, padding: '20px 28px', display: 'flex', alignItems: 'center', gap: '20px', justifyContent: 'space-between', flexWrap: 'wrap' }}>
        <span className="pktd-header-title" style={{ fontSize: '34px', fontWeight: 900, color: C.white, letterSpacing: '0.06em', textTransform: 'uppercase', lineHeight: 1 }}>MADRID</span>
        <span className="pktd-header-meta" style={{ fontSize: '16px', color: 'rgba(255,255,255,0.7)', fontWeight: 500 }}>7 notti &nbsp;·&nbsp; 2 adulti</span>
        <div style={{ textAlign: 'right' }}>
          <div className="pktd-header-price" style={{ fontSize: '26px', fontWeight: 900, color: C.white, lineHeight: 1 }}>€ 800,00</div>
          <div className="pktd-header-sub" style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)', marginTop: '3px' }}>spesa indicativa</div>
        </div>
      </div>

      {/* 2x2 GRID — due righe separate per centrare il logo esattamente sul bordo */}
      <div>

        {/* RIGA 1: Trasporto + Alloggio */}
        <div className="pktd-row" style={{ position: 'relative' }}>

          {/* LOGO MONDO — bottom:-25px = metà del cerchio (50px) sul bordo tra le righe */}
          <div className="pktd-logo" style={{
            position: 'absolute', bottom: '-25px', left: '50%',
            transform: 'translateX(-50%)', zIndex: 10,
            backgroundColor: C.white, borderRadius: '50%',
            width: '50px', height: '50px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 2px 10px rgba(0,0,0,0.13)',
            border: `2px solid ${C.border}`,
          }}>
            <img src="/images/logo_mondo.svg" alt="OCTA" style={{ width: '30px', height: '30px', objectFit: 'contain' }} />
          </div>

          {/* TRASPORTO */}
          <div className="pktd-cell pktd-cell-tl" style={{ padding: '14px 16px', borderRight: `2px solid ${C.border}`, borderBottom: `2px solid ${C.border}` }}>
            <SegLabel colore={C.trasporto} img="/images/trasporto_icona.png" label="TRASPORTO" />
            <VologRow direz="Andata" oraPart="19.25" cittaPart="VERONA" durata="2h 05m" tipo="diretto" oraArr="21.30" cittaArr="MADRID" prezzo="€ 112,00" colore={C.trasporto} />
            <div className="pktd-volo-gap" style={{ height: '6px' }} />
            <VologRow direz="Ritorno" oraPart="16.25" cittaPart="MADRID" durata="2h 05m" tipo="diretto" oraArr="18.30" cittaArr="VERONA" prezzo="€ 112,00" colore={C.trasporto} />
          </div>

          {/* ALLOGGIO */}
          <div className="pktd-cell" style={{ padding: '14px 16px', borderBottom: `2px solid ${C.border}` }}>
            <SegLabel colore={C.alloggio} img="/images/alloggio_icona.png" label="ALLOGGIO" />
            <div className="pktd-alloggio-head" style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '10px', marginBottom: '8px' }}>
              <div>
                <div className="pktd-alloggio-title" style={{ fontSize: '17px', fontWeight: 900, fontStyle: 'italic', color: C.text }}>HOTEL PLAZA<span style={{ color: '#f59e0b' }}>★★★★</span></div>
                <div className="pktd-alloggio-meta" style={{ fontSize: '13px', color: C.text, marginTop: '3px' }}>camera matrimoniale · bagno · 32 m²</div>
                <div className="pktd-alloggio-meta" style={{ fontSize: '13px', color: C.text }}>cucina pvt · bagno pvt</div>
              </div>
              <div style={{ textAlign: 'right', flexShrink: 0 }}>
                <div className="pktd-alloggio-price" style={{ fontSize: '17px', fontWeight: 900, color: C.text }}>€ 273,00</div>
                <div style={{ marginTop: '4px', display: 'inline-flex', alignItems: 'center', gap: '4px', backgroundColor: '#e8f5e9', borderRadius: '5px', padding: '3px 6px' }}>
                  <span style={{ fontSize: '11px', fontWeight: 700, color: C.servizi, textTransform: 'uppercase' }}>OTTIMA</span>
                  <span style={{ fontSize: '13px', fontWeight: 900, color: C.white, backgroundColor: C.alloggio, borderRadius: '3px', padding: '1px 5px' }}>8.5</span>
                </div>
              </div>
            </div>
            <div className="pktd-features" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px 12px', marginTop: '8px', borderTop: `1px solid ${C.border}`, paddingTop: '8px' }}>
              {['Pulizia camera ogni mattina','Rete wi-fi in camera','Smart TV + 100 canali','Servizio in camera','Ascensore','Prenotazione biglietti'].map((s, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <span style={{ width: '4px', height: '4px', borderRadius: '50%', backgroundColor: C.alloggio, flexShrink: 0 }} />
                  <span className="pktd-feature-text" style={{ fontSize: '13px', color: C.text }}>{s}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* RIGA 2: Servizi + Attività */}
        <div className="pktd-row">

          {/* SERVIZI */}
          <div className="pktd-cell pktd-cell-bl" style={{ padding: '14px 16px', borderRight: `2px solid ${C.border}` }}>
            <SegLabel colore={C.servizi} img="/images/servizi_icona.png" label="SERVIZI" />
            {[
              { nome: 'Collegamento areoportuale A/R', prezzo: '€ 40,00' },
              { nome: 'Noleggio bici', prezzo: '€ 60,00' },
              { nome: 'Noleggio auto "Fiat Panda"', prezzo: '€ 280,00' },
            ].map((item, i) => (
              <div key={i} className="pktd-list-row" style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '5px 0', borderBottom: i < 2 ? `1px solid ${C.border}` : 'none' }}>
                <span style={{ width: '5px', height: '5px', borderRadius: '50%', backgroundColor: C.servizi, flexShrink: 0 }} />
                <span className="pktd-list-text" style={{ flex: 1, fontSize: '16px', color: C.text }}>{item.nome}</span>
                <span style={{ fontSize: '11px', color: C.servizi, border: `1px solid ${C.servizi}`, borderRadius: '3px', padding: '1px 6px', fontWeight: 600, whiteSpace: 'nowrap' }}>dettagli</span>
                <span className="pktd-list-price" style={{ fontSize: '17px', fontWeight: 800, color: C.text, minWidth: '60px', textAlign: 'right' }}>{item.prezzo}</span>
              </div>
            ))}
          </div>

          {/* ATTIVITÀ */}
          <div className="pktd-cell" style={{ padding: '14px 16px' }}>
            <SegLabel colore={C.attivita} img="/images/attivita_icona.png" label="ATTIVITÀ" />
            {[
              { nome: 'Tour stadio "Santiago Bernabeu"', prezzo: '€ 120,00' },
              { nome: 'Spettacolo di Flamenco al Tablao Las Carboneras', prezzo: '€ 120,00' },
              { nome: 'Degustazione vini e preparazione tapas', prezzo: '€ 60,00' },
              { nome: 'Tour stadio "Wanda Metropolitano"', prezzo: '€ 150,00' },
              { nome: "Giro in quad nell'Alpuijarra granadina", prezzo: '€ 110,00' },
            ].map((item, i, arr) => (
              <div key={i} className="pktd-list-row" style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '5px 0', borderBottom: i < arr.length - 1 ? `1px solid ${C.border}` : 'none' }}>
                <span style={{ width: '5px', height: '5px', borderRadius: '50%', backgroundColor: C.attivita, flexShrink: 0 }} />
                <span className="pktd-list-text" style={{ flex: 1, fontSize: '16px', color: C.text, lineHeight: 1.3 }}>{item.nome}</span>
                <span style={{ fontSize: '11px', color: C.attivita, border: `1px solid ${C.attivita}`, borderRadius: '3px', padding: '1px 6px', fontWeight: 600, whiteSpace: 'nowrap', flexShrink: 0 }}>dettagli</span>
                <span className="pktd-list-price" style={{ fontSize: '17px', fontWeight: 800, color: C.text, minWidth: '60px', textAlign: 'right', flexShrink: 0 }}>{item.prezzo}</span>
              </div>
            ))}
          </div>
        </div>

      </div>

      {/* 86% MATCH */}
      <div className="pktd-footer" style={{ padding: '10px 24px', backgroundColor: C.dark, display: 'flex', alignItems: 'center', gap: '12px' }}>
        <span className="pktd-footer-pct" style={{ fontSize: '20px', fontWeight: 900, color: C.white, textDecoration: 'underline', textDecorationColor: C.trasporto, textDecorationThickness: '3px' }}>86%</span>
        <span className="pktd-footer-text" style={{ fontSize: '16px', color: C.white, fontWeight: 400 }}>In linea con il tuo profilo e le tue aspettative</span>
      </div>

    </div>
  );
}

function SegLabel({ colore, img, label, noMargin, alignLeft }) {
  return (
    <div className="pktd-seglabel" style={{ display: 'flex', alignItems: 'center', justifyContent: alignLeft ? 'flex-start' : 'center', gap: '7px', marginBottom: noMargin ? 0 : '12px' }}>
      <img src={img} alt={label} className="pktd-seglabel-icon" style={{ height: '18px', objectFit: 'contain' }} />
      <span className="pktd-seglabel-text" style={{ fontSize: '13px', fontWeight: 900, color: colore, textTransform: 'uppercase', letterSpacing: '0.12em' }}>{label}</span>
    </div>
  );
}

function VologRow({ direz, oraPart, cittaPart, durata, tipo, oraArr, cittaArr, prezzo, colore }) {
  return (
    <div>
      <div className="pktd-volo-badge-row" style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '5px' }}>
        <span style={{ backgroundColor: colore, color: '#fff', fontSize: '11px', fontWeight: 800, padding: '2px 7px', borderRadius: '3px', letterSpacing: '0.04em' }}>{direz}</span>
        <span style={{ color: colore, fontSize: '13px' }}>✈</span>
        <span style={{ marginLeft: 'auto', fontSize: '11px', color: colore, border: `1px solid ${colore}`, borderRadius: '3px', padding: '1px 6px', fontWeight: 600 }}>dettagli</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
        <div style={{ textAlign: 'left' }}>
          <div className="pktd-volo-time" style={{ fontSize: '17px', fontWeight: 900, color: C.text, lineHeight: 1 }}>{oraPart}</div>
          <div className="pktd-volo-city" style={{ fontSize: '13px', color: C.text, textTransform: 'uppercase', letterSpacing: '0.06em', marginTop: '1px' }}>{cittaPart}</div>
        </div>
        <div style={{ flex: 1, textAlign: 'center', minWidth: '60px' }}>
          <div className="pktd-volo-mid" style={{ fontSize: '13px', fontWeight: 700, color: C.text }}>{durata}</div>
          <div style={{ height: '1px', backgroundColor: C.border, margin: '2px 0', position: 'relative' }}>
            <span style={{ position: 'absolute', right: 0, top: '-5px', color: C.text, fontSize: '11px' }}>▶</span>
          </div>
          <div className="pktd-volo-mid" style={{ fontSize: '13px', color: C.text }}>{tipo}</div>
        </div>
        <div style={{ textAlign: 'left' }}>
          <div className="pktd-volo-time" style={{ fontSize: '17px', fontWeight: 900, color: C.text, lineHeight: 1 }}>{oraArr}</div>
          <div className="pktd-volo-city" style={{ fontSize: '13px', color: C.text, textTransform: 'uppercase', letterSpacing: '0.06em', marginTop: '1px' }}>{cittaArr}</div>
        </div>
        <div className="pktd-volo-price" style={{ fontWeight: 900, fontSize: '17px', color: C.text, marginLeft: 'auto' }}>{prezzo}</div>
      </div>
    </div>
  );
}
